import { Injectable } from '@angular/core';
import { DvCheckboxElement } from '@devinco/ui/legacy';

@Injectable()
export class VehicleTripTypeSetupTabService {
  setupElements = [
    new DvCheckboxElement({
      key: 'VehicleIntervalSetting',
      checkboxLabel: 'VehicleTypeSetup.VehicleIntervalSetting',
      colspan: 12,
    }),
    new DvCheckboxElement({
      key: 'Holidays',
      checkboxLabel: 'TripTypeSetupInformationTab.Holidays',
      colspan: 12,
      disabled: true,
    }),
  ];
}
